import { ServerFetch } from '../main-model'

export default class PurchaseRequestListModel extends ServerFetch {
    getPurchaseRequestListBy = (data) => this.authFetch({
        url: 'purchase-request-list/getPurchaseRequestListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}